import axios from "axios";
import { showErrorMessage } from "./utils";
const BaseURL = process.env.REACT_APP_BASE_URL

const hospitalServices = {

    getDepartMents() {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}hospital/getDepartments`);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },


    updateHospital(formBody) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.patch(`${BaseURL}hospital/info`, formBody);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    getHospitalProfile() {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}hospital/profile`);
                resolve(resp.data)
            } catch (err) {
                showErrorMessage({ message: "There is some network/server issue" })
                reject(err)
            }

        })
    },
    getSharedFiles(formBody,query = "") {                           ///Administrative Documents
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}hospital/getSharedFolderAndFiles?hospital_id=${formBody}${query}`);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    getHospitalSharedFiles(formBody) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}hospital/getSharedFolder/${formBody}`);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },
    giveSubadminProgramPrivillege(body) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.post(`${BaseURL}hospital/giveSubadminProgramPrivillege`,body);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },

    getFilesData(formBody) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.post(`${BaseURL}hospital/get/document`, formBody);
                resolve(resp.data)
            } catch (err) {
                reject(err)
            }

        })
    },
    getRotationHospital(date) {
        return new Promise(async (resolve, reject) => {

            try {
                const resp = await axios.get(`${BaseURL}hospital/getRotationRequests?date=${date}`);

                resolve(resp)
            } catch (err) {
                reject(err)
            }

        })
    },
    createFileFolder(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`${BaseURL}hospital/addHospitalCustom`, reqData);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getFileFolder(reqData, query="") {                           //my file in dashboard
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/getHospitalCustom?createdBy_id=${reqData}${query}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    deleteFileFolder(reqData) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`${BaseURL}hospital/deleteFolderFiles?id=${reqData.id}&type=${reqData.type}`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getSchoolList() {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/college/list`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getSchoolListSubAdmin() {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/getSchlsAccToRotationReq`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getHospitalList() {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/reghospitals`);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    shareFolders(req) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`${BaseURL}hospital/share/documents`, req);
                resolve(resp)
            } catch (err) {
                reject(err)
            }
        })
    },
    getSignaturedDocs(reqData, reqname = "") {     
                                  //student contract
        return new Promise(async (resolve, reject) => {
            try {
                if (reqData === "folder") {
                    const resp = await axios.get(`${BaseURL}school/getSharedSignedDocs?type=${reqData}${reqname}`);
                    resolve(resp)
                }
                else {
                    const resp = await axios.get(`${BaseURL}school/getSharedSignedDocs?school_id=${reqData}`);
                    resolve(resp)
                }

            } catch (err) {
                reject(err)
            }
        })
    },

    getSchoolList() {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/getSchlsAccToHospitals`)
                resolve(resp)
            }
            catch (err) {
                reject(err)
            }
        }
        )
    },
   
    getRotationReqAccToSchl(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/getRotationReqAccToSchlAndPrgm?school_id=${data}`)
                resolve(resp)
            }
            catch (err) {
                reject(err)
            }
        }
        )
    },
    getRotationReqStudentDetail(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/getRotationReqStudentDetail?rotation_req_id=${data}`)
                resolve(resp)
            }
            catch (err) {
                reject(err)
            }
        }
        )
    },
    getRotationProgramsAccToSchl(data,sub_admin_id){
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.get(`${BaseURL}hospital/getRotationProgramsAccToSchl?school_id=${data}&sub_admin_id=${sub_admin_id}`)
                resolve(resp)
            }
            catch (err) {
                reject(err)
            }
        }
        )
    }
}

export default hospitalServices